import { Injectable, inject } from '@angular/core';
import { ModalController } from '@ionic/angular';
import { AgendaLegendHandler } from '@libs/util-services';
import { AgendaLegendModalComponent } from './agenda-legend-modal.component';

@Injectable({ providedIn: 'root' })
export class AgendaLegendService implements AgendaLegendHandler {
  private readonly modalCtrl = inject(ModalController);

  async openLegend(): Promise<void> {
    const modal = await this.modalCtrl.create({
      component: AgendaLegendModalComponent,
      cssClass: 'agenda-legend-modal',
      backdropDismiss: true,
      showBackdrop: true,
    });
    await modal.present();
  }
}
